import {ADICIONAR_FILTRO_PRESTADOR, REMOVER_FILTRO_PRESTADOR} from '../../actions/types'
import {filtroExiste} from '../../util/filtros'

const initialState = undefined

export const filtrosAdicionadosPrestador = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_PRESTADOR: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_PRESTADOR: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    default:
      return state
  }
};
